<template>
    <div class="answers-buttons">      
      <h2
        v-if="actualView.subTitle"
        class="answers-checkboxes-title">
          {{actualView.subTitle}}
      </h2>

      <AnswerHint
        v-if="actualView.hints"
        :numberTry = actualProperty.numberTry
        :totalHints = actualView.totalHints
        :hintText = actualView.hintText
      />
      <ul 
        v-if="actualView.answersButtonType==='buttons'"
        class="answers-buttons-grid"
      >
        <UniversalAnswerButton
          v-for="(item,index) in actualProperty.answersList"
          :key="index"
          :answerText = actualView.bodyAnswers[index].answerText
          :isSelected = item
          :isDisable = "actualProperty.completed"
          @click="selectItem(index)"
        />
      </ul>
      <ul 
        v-if="actualView.answersButtonType==='checkboxes'"
        class="answers-checkboxes-grid"
      >
        <UniversalAnswerCheckbox 
          v-for="(item,index) in actualProperty.answersList"
          :key="index"
          :answerText = actualView.bodyAnswers[index].answerText
          :isSelected = item
          :isDisable = actualProperty.completed
          @click="selectItem(index)"
        />
      </ul>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import UniversalAnswerButton from '@/components/game/UniversalAnswerButton.vue'
import UniversalAnswerCheckbox from '@/components/game/UniversalAnswerCheckbox.vue'
import AnswerHint from '@/components/game/AnswerHint.vue'

export default {
    name: "UniversalAnswers",
    components: {
      UniversalAnswerButton,
      UniversalAnswerCheckbox,
      AnswerHint
    },
    computed: {
      ...mapGetters([
        "actualView",
        'actualProperty',
        "stepNumber"
      ]),    
    },
    methods: {
      ...mapActions([
        "setAnswer",
        "clearAnotherAnswers"
      ]),
      selectItem(index){
        if (this.actualProperty.completed) {
          return
        }
        this.setAnswer(index)
        if (!this.actualView.multiple) {
          this.clearAnotherAnswers(index)
        }
        
      }
    }
}
</script>

<style>
    
</style>